export const ADMIN_SCROLL_CONTAINER_SELECTOR = '[data-admin-scroll-container]';

export function getAdminScrollContainer(): HTMLElement | null {
  if (typeof document === 'undefined') return null;
  return document.querySelector<HTMLElement>(ADMIN_SCROLL_CONTAINER_SELECTOR);
}

export function getAdminScrollTop(): number {
  const container = getAdminScrollContainer();
  if (container) return container.scrollTop;
  return window.scrollY || window.pageYOffset || 0;
}

export function setAdminScrollTop(top: number) {
  const container = getAdminScrollContainer();
  if (container) {
    container.scrollTop = top;
    return;
  }
  window.scrollTo(0, top);
}

export function getAdminScrollMetrics(): {
  scrollHeight: number;
  viewportHeight: number;
} {
  const container = getAdminScrollContainer();
  if (container) {
    return { scrollHeight: container.scrollHeight, viewportHeight: container.clientHeight };
  }

  const scrollHeight = Math.max(
    document.documentElement.scrollHeight,
    document.body.scrollHeight
  );
  return { scrollHeight, viewportHeight: window.innerHeight };
}

